import { render, staticRenderFns } from "./utilities-electricity.vue?vue&type=template&id=272e6636"
import script from "./utilities-electricity.vue?vue&type=script&lang=js"
export * from "./utilities-electricity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports